export const LABOR_COST_SECTIONS = Object.freeze([
  { id: 'schedule', label: 'График', permissions: ['schedule.self', 'schedule.manage'] },
  { id: 'master', label: 'Мастер график', permissions: ['schedule.manage'] },
  { id: 'calculation', label: 'Расчёт', permissions: ['payroll.tab'] },
  { id: 'operations', label: 'Операции', permissions: ['payroll.tab'], team: true },
  { id: 'settings', label: 'Настройки оплаты', admin: true }
]);

export function laborCostSections(auth) {
  return LABOR_COST_SECTIONS.filter(section => {
    if (section.admin) return auth.isAdmin;
    if (!section.permissions.some(permission => auth.hasPermission(permission))) return false;
    return !section.team || auth.isAdmin || auth.hasPermission('payroll.restaurant') || auth.hasPermission('payroll.network');
  });
}

export function laborCostQuery(query = {}) {
  const shared = {};
  for (const key of ['restaurantId', 'weekStart', 'date', 'from', 'to']) {
    if (typeof query[key] === 'string' && query[key]) shared[key] = query[key];
  }
  const anchor = shared.date || shared.from;
  if (!shared.weekStart && /^\d{4}-\d{2}-\d{2}$/.test(anchor || '')) {
    const day = new Date(`${anchor}T12:00:00Z`);
    if (Number.isFinite(day.getTime())) {
      day.setUTCDate(day.getUTCDate() - ((day.getUTCDay() || 7) - 1));
      shared.weekStart = day.toISOString().slice(0, 10);
    }
  }
  return shared;
}

export function laborCostLocation(section = 'schedule', query = {}) {
  return { path: `/labor-cost/${section}`, query: laborCostQuery(query) };
}

export function legacyLaborCostLocation(path, query = {}) {
  if (path === '/schedule') return { path: `/labor-cost/${query.mode === 'master' ? 'master' : 'schedule'}`, query };
  if (path === '/payroll/cost') return { path: '/labor-cost/cost', query };
  if (path === '/settings' || ['rules', 'taxes'].includes(query.tab)) return laborCostLocation('settings', query);
  if (query.tab === 'overview') return { ...laborCostLocation('schedule', query), query: { ...laborCostQuery(query), periodMode: query.periodMode || (query.from === query.to ? 'day' : 'month') } };
  const operations = ['operations', 'adjustments', 'bonuses', 'expenses'].includes(query.tab);
  return { path: `/labor-cost/${operations ? 'operations' : 'calculation'}`, query };
}
